import { SocialIcon } from './FooterIcons'

function FooterSocial({ social, variant = 'light' }) {
  if (!social?.length) return null

  return (
    <div className={`footer-social footer-social--${variant}`}>
      {social.map(({ name, url }) => (
        <a
          key={name}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="footer-social__link"
          aria-label={name}
        >
          <SocialIcon name={name} />
        </a>
      ))}
    </div>
  )
}

export default FooterSocial
